import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/shared/animation/BuilderContentWithTransition.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/builder-registry.ts");
